module.exports = __webpack_public_path__ + "img/header_background@2x.6d05fc5f.png";